export default __webpack_public_path__ + "img/redge-light.47a97c37.png";